<div class="d-flex">
  <div
    ngbDropdown
    class="dropdown d-inline-flex m-auto"
    container="body"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
  >
    <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

    <div ngbDropdownMenu class="dropdown-menu common-dropdown-menu">
      @if (!isPrimaryContact) {
        <div
          ngbDropdownItem
          class="dropdown-item"
          (click)="onSetContactAsPrimary()"
        >
          <i class="icon ic-set-as-default-20"></i>
          <span class="title">Set as Primary Contact</span>
        </div>
      }

      <div
        ngbDropdownItem
        class="dropdown-item"
        (click)="onEditContact()"
      >
        <i class="icon ic-edit-20"></i>
        <span class="title">Edit Contact</span>
      </div>

      <div
        ngbDropdownItem
        class="dropdown-item delete-button"
        (click)="onDeleteContact()"
      >
        <i class="icon ic-close-20"></i>
        <span class="title">Delete</span>
      </div>
    </div>
  </div>

</div>
